import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { PaymentService } from 'src/app/services/payment.service';
import { Location } from '@angular/common';

interface State {
  id: number;
  state_name: string;
}

@Component({
    selector: 'app-add-branch-wallet-balance',
    templateUrl: './add-branch-wallet-balance.component.html',
    styleUrls: ['./add-branch-wallet-balance.component.scss'],
    standalone: false
})

export class AddBranchWalletBalanceComponent implements OnInit {

  addWalletForm: FormGroup;
  addNewWalletDetails!: FormArray;
  submitted: boolean = false;
  branches: any = [];
  stamp_types = [
    { code: 'PHYSTMAP', name: "physical" },
    { code: 'ESTAMP', name: "estamp" },
    { code: 'ESBTR', name: "esbtr" },
    { code: 'ECHALLAN', name: "echallan" }
  ];
  typeData: { code: string; name: string; }[];
  walletId: any;
  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private paymentService: PaymentService,
    private router: Router,
    private location: Location,
    private activatedRouter: ActivatedRoute
  ) {
    this.addWalletForm = this.formBuilder.group({
      addNewWalletDetails: this.formBuilder.array([])
    });

    this.activatedRouter.params.subscribe((params) => {
      this.walletId = params['id'];
    });
  }

  ngOnInit(): void {
    this.getStates()
    this.walletDetailsArray().push(this.initWalletDetails())
  }

  getStates() {
    this.paymentService.getBranchList().subscribe((res: any) => {
      this.branches = res['content'];
    })
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  removeDetails(index: number) {
    this.walletDetailsArray().removeAt(index);
  }

  walletDetailsArray(): FormArray {
    return this.addWalletForm.get("addNewWalletDetails") as FormArray;
  }

  addnewWalletDetail() {
    if (this.addWalletForm.controls['addNewWalletDetails'].valid) {
      this.walletDetailsArray().push(this.initWalletDetails())
    }

    else {
      this.messageService.add({ severity: 'warn', summary: 'New user', detail: 'Please fill user details before adding New' });
    }
  }

  initWalletDetails() {
    return this.formBuilder.group({
      branch: new FormControl(null, [Validators.required]),
      amount: new FormControl(null, [Validators.required])
    });
  }

  saveDetails() {
    this.submitted = true;
   
    if (this.addWalletForm.invalid) {
   
      return;
    }

    const addNewWalletDetailsFormArray = this.addWalletForm.get('addNewWalletDetails') as FormArray;
    const walletDetailsArray: any[] = [];

    // Iterate over each FormGroup in the FormArray
    addNewWalletDetailsFormArray.controls.forEach((abstractControl: AbstractControl) => {
      if (abstractControl instanceof FormGroup) {
        const formGroup = abstractControl as FormGroup;
        var walletDetail = {
          branch_id: formGroup.controls['branch'].value,
          amount: formGroup.controls['amount'].value
        };
        walletDetailsArray.push(walletDetail);
      }
    });

   

    let reqdata = {
      "state_wallet_id": this.walletId,
      "branch_wallet": walletDetailsArray
    }

    this.paymentService.addNewBranchWallet(reqdata).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.messageService.add({ severity: 'success', summary: res.message });
          setTimeout(() => {
            this.location.back();
          }, 500)
        }
      },
      (error: any) => {
      
        this.messageService.add({ severity: 'error', summary: error.error.message });
      });
  }

  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) || event.keyCode == 45) {
      event.preventDefault();
    } else if (event.target.value === '0') {
      event.preventDefault();
    }
  }

  back() {
    this.location.back();
  }

  getAvailableStates(index: number): State[] {
    const selectedStates = this.getSelectedStates();
    const availableStates = this.branches.filter(state => !selectedStates.includes(state.id));
    return availableStates;
  }

  private getSelectedStates(): number[] {
    const statesArray = this.addWalletForm.get('walletDetailsArray') as FormArray;
    const selectedStateIds = statesArray.controls.map(control => control.value);
    return selectedStateIds;
  }

  onStateSelect(event: any, index: number) {
    const selectedBranchId = event.value; // Assuming the selected value is the state's ID

    // Remove the selected state name in the second index selection
    if (index === 1) {
      const branchArray = this.addWalletForm.get('walletDetailsArray') as FormArray;
      const selectedBranchControl = branchArray.controls[1] as FormControl;
      if (selectedBranchControl.value === selectedBranchId) {
        selectedBranchControl.setValue(null);
      }
    }

    // Additional logic based on the selection if needed
  }

}
